import { ClassType, EntityType } from '@frontend/common';
import { DefaultBadge } from '@frontend/components/badge';
import { StatusBadge, accountIdFromResolvedEntity } from '@frontend/components/common';
import { IoTExtended, IoTType } from '@frontend/iot/types';
import { CommonMessage } from '@frontend/lang';
import React from 'react';
import { FormattedMessage } from 'react-intl';

import { MasterPinCodeContainer } from '../../applications/modals/iot-detail-modal/master-pin-code-container/master-pin-code-container.component';
import { SettingsList } from '../../components/settings-list/settings-list.component';
import { PlatformDetailGrid } from '../../modal/platform-detail-grid/platform-detail-grid.component';
import { PlatformObjectBadge } from '../../modal/platform-object-badge/platform-object-badge.component';

export const IOT_SETTINGS_LABEL = (
    <FormattedMessage
        id='platform.iot.modal.iot.reactive-detail.settings-tab'
        description='Tab label for IoT settings on the IoT detail pane'
        defaultMessage='Settings'
    />
);

export const IoTDetailsCard = ({ iot }: { iot: IoTExtended }) => (
    <div className='bg-background-surface outline-border-default inline-flex w-full flex-col items-start justify-start gap-6 self-stretch rounded-xl p-4 outline-1 outline-offset-[-1px]'>
        <div className='text-foreground-default justify-start text-xl font-semibold'>{CommonMessage.DETAIL.DETAILS}</div>
        <PlatformDetailGrid
            object={iot}
            cols={3}
            order={['name', 'type', 'creation_timestamp', 'version', 'heartbeat_timestamp', 'status', 'spot']}
            keyOverwrite={new Map([['name', CommonMessage.OBJECTS.IOT.ASSET_NAME]])}
            valueOverwrite={
                new Map<string, (obj: IoTExtended) => React.ReactNode>([
                    [
                        'spot',
                        (obj) =>
                            obj.spot ? (
                                <PlatformObjectBadge
                                    entityType={obj.spot.entity_type}
                                    id={obj.spot.entity_id}
                                    display={obj.spot.name}
                                    foreign={obj.spot.foreign}
                                    accountId={accountIdFromResolvedEntity(obj.spot)}
                                />
                            ) : (
                                <span>/</span>
                            )
                    ],
                    [
                        'type',
                        (obj) => (
                            <DefaultBadge
                                label={obj.type.replace(/_/g, ' ')}
                                styles={{ container: { color: 'bg-brand-muted' } }}
                            />
                        )
                    ],
                    [
                        'status',
                        (obj) => (
                            <StatusBadge
                                value={obj.status}
                                colorMap={
                                    new Map([
                                        [['offline'], ClassType.DANGER],
                                        [['online'], ClassType.SUCCESS]
                                    ])
                                }
                            />
                        )
                    ]
                ])
            }
        />
    </div>
);

export const IoTGeneralSection = ({ iot }: { iot: IoTExtended }) =>
    iot.type === IoTType.ACCESS_CONTROLLER ? <MasterPinCodeContainer iot_id={iot.id} /> : null;

export const IoTSettingsSection = ({ iot }: { iot: IoTExtended }) => (
    <SettingsList
        entity_id={iot.id}
        entity_type={EntityType.IOT}
    />
);
